import React from 'react';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import { setSearchTerm } from '@repo/redux/actions/search';
import styles from './Hashtag.module.scss';
import { useInRouterContext, useLocation, useNavigate } from 'react-router-dom';

export function ClickableHashtag(props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleHashtagClick = (e) => {
    e.preventDefault();
    dispatch(setSearchTerm(props.decoratedText, true));
    if (location.pathname !== '/search') {
      navigate('/search');
    }
  };

  return (
    <span className={styles.hashtag} onClick={handleHashtagClick}>
      {props.children}
    </span>
  );
}

export default function Hashtag(props) {
  const isInRouter = useInRouterContext();

  if (isInRouter) {
    return <ClickableHashtag {...props} />;
  }

  return <span className={cn(styles.hashtag, styles.notClickable)}>{props.children}</span>;
}
